import templateUrl from './treat-admin-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administration: '<',
    administrations: '<',
    units: '<',
    animalTypes: '<',
    frequencies: '<',
    submitTitle: '@',
    unitsDisplay: '<',
    administrationChanged: '&',
    index: '<',
    showAdditionalButton: '<'
  },
  controller: class TreatAdminFormComponent {
    constructor(AnimalTypeService, EventEmitter) {
      'ngInject';

      Object.assign(this, {
        AnimalTypeService,
        EventEmitter
      });
    }

    onSubmit(shouldClose) {
      const administration = {
        Isloading: false,
        MinWeight: this.AnimalTypeService.minimumAnimalWeight(this.administration.Species),
        MaxWeight: this.AnimalTypeService.maximumAnimalWeight(this.administration.Species),
        DoseAmount: 1,
        DosePerDay: 1.00,
        ...this.administration
      };

      if (!administration.DoseId) {
        this.administrations.push(administration);
      }

      this.administrationChanged(
        this.EventEmitter({
          administration,
          index: this.index,
          shouldClose
        }));

      this.validateDuplicates();
    }

    getMinimumAnimalWeight(species) {
      return this.AnimalTypeService.minimumAnimalWeight(species);
    }

    getMaximumAnimalWeight(species) {
      return this.AnimalTypeService.maximumAnimalWeight(species);
    }

    calculateAdminDays() {
      return Math.round(this.units / (this.administration.DoseAmount * this.administration.DosePerDay));
    }

    validateDuplicates() {
      let isValid = true;

      if (this.administration) {
        const arrayIndex = this.administrations.findIndex(d =>
          d.Isloading === false
          && d.Species === this.administration.Species
        );

        if (arrayIndex !== -1 && arrayIndex !== this.index) {
          isValid = false;
        }
      }

      this.treatAdministrationForm.$setValidity('duplicate', isValid);
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/treat-admin-form/treat-admin-form.component.js